/**
 * ─────────────────────────────────────────────
 * src/services/dashboardService.js
 * ─────────────────────────────────────────────
 *
 * WHY: Only place that knows dashboard API URLs.
 *
 * Covers:
 *   GET /api/dashboard           → stats + projectOverview + upcomingMilestones
 *   GET /api/dashboard/projects  → full sortable project list
 *   GET /api/dashboard/graphs    → weeklyProgress, overallCompletion, resourceAllocation
 */

import api from "../lib/api";

const getDashboard = async (sortBy = "") => {
  const url = sortBy ? `/dashboard?sortBy=${sortBy}` : "/dashboard";
  const response = await api.get(url);
  return response.data;
  // Returns: { success, data: { stats, projectOverview, upcomingMilestones } }
};

const getDashboardProjects = async (sortBy = "", disabled = false) => {
  const params = new URLSearchParams();
  if (sortBy) params.set("sortBy", sortBy);
  if (disabled) params.set("disabled", "true");
  const query = params.toString();
  const url = query ? `/projects?${query}` : "/projects";
  const response = await api.get(url);
  return response.data;
  // Returns: { success, data: [...projects] }.
};

const getDashboardGraphs = async (projectId = "") => {
  const url = projectId
    ? `/dashboard/graphs?projectId=${projectId}`
    : "/dashboard/graphs";
  const response = await api.get(url);
  return response.data;
};

const dashboardService = {
  getDashboard,
  getDashboardProjects,
  getDashboardGraphs,
};

export default dashboardService;
